import { render, staticRenderFns } from "./prodottiPolize.vue?vue&type=template&id=79396c4b&"
import script from "./prodottiPolize.vue.ts?vue&type=script&lang=ts&"
export * from "./prodottiPolize.vue.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports